<template>
  <div>
    <el-dialog title="添加取值" :visible.sync="dialogValue" width="50%" :before-close="valueCancel">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">类型：</span>
          </div>
          <el-input v-model="formDataValue.type" disabled size="small" style="width: 280px">
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">名称：</span>
          </div>
          <el-input v-model="formDataValue.name" size="small" style="width: 280px">
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">取值：</span>
          </div>
          <el-input v-model="formDataValue.value" size="small" style="width: 280px">
          </el-input>
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="valueCancel">取 消</el-button>
        <el-button size="small" type="primary" @click="valueConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import TextTitle from "../../../components/Text/TextTitle";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TableMain from "../../../components/Table/TableMain";

export default {
  name: "valueDialog",
  props: {
    dialogValue: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formDataValue: {
        type: '自定义取值',
        name: '',
        value: ''
      },
    }
  },
  methods: {
    // 取消
    valueCancel() {
      this.$emit('valueCancel');
    },

    // 提交
    valueConfirm() {
      this.$emit('valueConfirm',this.formDataValue)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/Invoice/invoiceremarks/valueDialog.vue